import React from 'react';
import i18n from "i18next";
import { Layout, Empty, Modal, Tabs, Row, Col, Collapse } from 'antd';

import { AdmsAsset, EMDActions, ModelViews } from '../../redux';
import { getNameAsset } from '../../components/adms/helper';
import AssetData from '../../components/adms/AssetData';
import TaxonomyCard from '../../components/skos/TaxonomyValues';
import EMDTable from '../../components/emd/EMDTable';
import EMDGraph from '../../components/emd/EMDGraph';
import UMLDiagramm from '../../components/emd/popUpUML';
import XSDDiagramm from '../../components/emd/popUpXSD';
import CLMDiagramm from '../../components/emd/popUpCLM';
import VOWLMaker  from '../../components/emd/popUpVOWL';
import DetailElement from '../../components/emd/popUpDetail';
import InfoElement from '../../components/emd/popUpInfo';
import { subsetTripletsByObject } from '../../virtuoso/helper'
import ViewsProxy from '../models/ViewsProxy';
import WikiValues from '../../components/wiki/WikiValues';
import ProcessInstaceLink from '../../components/lifecycle/ProcessInstaceLink';

const TabPane = Tabs.TabPane;
const { Panel } = Collapse;
const catalog = "http://hbz.ru/adms/catalog";

/** В качестве параметра приходит:
 * 1. IRI http://csi.semanticpro.org/ontologies/2016/adms#EMD 
 * IRI используется как имя графа в котором содержатся триплеты ЕМД 
 * */
const AssetTitle = names => {
    const single = names.length = 1;
    return (single)? names[0]: <span>names.map(name=> <p>{name}</p>)</span>;
}
//Отображение карточки 
const AssetDataProxy = ({values, lang, factory}) => 
<div className="csi_wrapper_content csi_inner_asset">
<Row>
    <Col className="asset_title" span={24}>{AssetTitle(getNameAsset(values, lang))}</Col>
</Row>
<Row>
    <Col className="assetCardTable" span={16}><AssetData operation="view" factory={factory}/> </Col>
    <Col className="properties_panel_wrapper" span={8}><TaxonomyCard operation="view" predicat="http://www.w3.org/ns/dcat#theme" factory={factory} /></Col>
</Row>
</div>            

const EMDGraphProxy = ({content}) => <EMDGraph content={content} />
const EMDTableProxy = ({onAction, content}) => <EMDTable onAction={onAction} content={content} />

const DumpProxy = () => <div>  <Empty description="Выберите на временной линии версию ЕМД." /></div>

const decodeIRIParams = match =>{
  return (match && match.params && match.params.id)?decodeURIComponent(match.params.id):null;
}

//Компонента отображения сожержания EMD. Включая отображения карточки ЕМД, ЕМД в табличной форме и ЕМД в форме графа
class EMDCard extends React.Component {
  
    constructor(props, context) {
        super(props, context)
        this.state = {
            visible: false,       //Отображаемое модальное окно
            loaded: false, 			  //Флаг загрузки (загрузка как карточки, так и содержимого ЕМД)
            action: undefined,    //Полняемое действия для модального окна
						operation: "view",    //Текущая операция над карточкой
						content: undefined,		//Содержимое ЕМД в виде ответа SPARQL
						vowl: undefined,			//Содержимое ЕМД в виде VOWL
						views: false,         //Загружены представления содержимого актива
					}
				this.onChangeView = this.onChangeView.bind(this);
    }
		
		static getDerivedStateFromProps(props, state) {
			//console.log("EMDCard.js static getDerivedStateFromProps(props, state)", decodeIRIParams(props.match), props.IRI, props.state, props, state);
			if ((decodeIRIParams(props.match)!=props.IRI)||(props.state=="empty") || !props.IRI ) { //|| !props.content
				return {loaded: false, operation: "view", detail: undefined, visible: false, content: undefined, vowl: undefined};
			}
			if ((decodeIRIParams(props.match)==props.IRI)||(props.state=="loaded")){
				//При переключении Tabs onChangeView после вызывается getDerivedStateFromProps и сбрасывает visible
				const visible = ["VOWL", "UML", "XSD", "CLM", "DETAIL", "INFO"].includes(state.action);
				return { ...state, loaded: true, visible};
			}
			return null; // Return null to indicate no change to state.
		}
	
    componentDidMount() { 
			const IRI = decodeIRIParams(this.props.match);
			if (!this.state.loaded && (IRI!=this.props.IRI) || (this.props.state=="empty"))
      	return Promise.all([this.props.onReload(AdmsAsset, EMDActions, catalog, IRI),this.props.onReloadViews(ModelViews, IRI)]);
				//return this.props.onReload(AdmsAsset, EMDActions, catalog, IRI);
		}

		componentDidUpdate(prevProps, prevState) {
			const IRI = decodeIRIParams(this.props.match);
			if (!this.state.loaded && ((IRI!=this.props.IRI)||(this.props.state=="empty") || !this.props.IRI))
				return this.props.onReload(AdmsAsset, EMDActions, catalog, IRI).then(response => {
					this.props.onReloadViews(ModelViews, IRI).then(views => {
						this.setState({views: true});
					});
				});
		}

	showModal = (record, text, modalWidth=undefined) => {
		console.log("EMDCard.js showModal", record, text, modalWidth);
		//Если это детальная информация
		if (text == "DETAIL"){
			this.setState({visible: true, action: text, selected: record, modalWidth});
			return;
		}
		if (text == "INFO"){
			this.setState({visible: true, action: text, selected: record, modalWidth});
			return;
		}
		//Определим по содержимому record.iri
		//Все доступные триплеты
		if (record && record.item && record.item.iri){
			record.triplets = subsetTripletsByObject(record.item.iri, this.props.content);
		}
    this.setState({visible: true, action: text, selected: record, modalWidth});
  };
    
    handleOk = e => {
        console.log(e);
        this.setState({visible: false, action: undefined});
    };

    //Событие об изменения формы отображения выбранной версии ЕМД
  onChangeView(e) {
		//e.preventDefault();
		//console.log(`EMDCard.js radio checked:${e}`);
		const {IRI, content, onReload} = this.props;
		const {vowl} = this.state;
		//console.log("EMDCard.js onChangeView(e)", IRI, content, vowl, !content, e);
		if (!content){
			return onReload(AdmsAsset, EMDActions, catalog, IRI)
				.then (response => {
					this.setState({visible: true, action:"VOWL"});	
				})
		} 
		if (!vowl || !Array.isArray(vowl.class) || (vowl.class.length <1))
			this.setState({visible: true, action:"VOWL"});
	}
		
	onMakeVOWL(vowl){
		this.setState({visible: false, action: undefined, vowl});
	}

  render() {
    console.log(this);
    const {loaded, vowl, operation} = this.state
    const {IRI, values, lang, factory, vviews} = this.props
		const props = { content: vowl, IRI, values, lang, factory};
		const modalProps = {title:"Элемент ЕМД", visible: this.state.visible};
		if (this.state.modalWidth) modalProps["width"] = this.state.modalWidth;
    const asset_json = {id: IRI};
    //Флаг, что есть представление для отображение содержимого 
    const views = vviews && Array.isArray(vviews.views) && vviews.views.length>0;
    //Описание view, если оно одно в списке
    const view = (views && vviews.views.length==1)? vviews.views[0]: undefined;
    return (
      (!loaded? <div>Загрузка</div>:
                <div>
                    <Row>
                        <Col span={24}>
	{!IRI? <DumpProxy {...props} /> :
<Tabs onChange={(e) => this.onChangeView(e)} type="card">
    <TabPane tab="Карточка" key="card"><AssetDataProxy {...props} /></TabPane>
    <TabPane tab="Грид" key="table"><EMDTableProxy onAction={this.showModal} {...props} /></TabPane>
    <TabPane tab="Граф" key="graph"><EMDGraphProxy {...props} /></TabPane>
		{views && (<TabPane tab="Содержимое" key="3"><ViewsProxy rpc_url={ModelViews.getRpc_url()} asset={asset_json} view={view} /></TabPane>)}
		<TabPane tab={i18n.t('views.adms.card_tab_collaboration')} key="2">
          <div className="csi_wrapper_content csi_inner_asset">
            <Row>
              <Collapse accordion>
                <Panel header={i18n.t('views.adms.collaboration.lifecycle_header')} key="1">
                  <ProcessInstaceLink IRI={IRI} />            
                </Panel>
                <Panel header={i18n.t('views.adms.collaboration.event_header')} key="2">
                  <p><b>{i18n.t('views.adms.collaboration.event_none')}</b></p>
                </Panel>
                <Panel header={i18n.t('views.adms.collaboration.wiki_header')} key="3">
                  <WikiValues operation={operation} predicat="http://hbz.ru/wiki" factory={factory} />
                </Panel>
              </Collapse>
            </Row>
          </div>            
        </TabPane>
</Tabs>
}  
                        </Col>
                    </Row>

        <Modal {...modalProps} onOk={this.handleOk} cancelButtonProps={{ disabled: true }}>
            {(this.state.action=="UML")&&<UMLDiagramm selected={this.state.selected}/>}
            {(this.state.action=="XSD")&&<XSDDiagramm selected={this.state.selected}/>}
            {(this.state.action=="CLM")&&<CLMDiagramm selected={this.state.selected} content={this.props.content}/>}
            {(this.state.action=="VOWL")&&<VOWLMaker content={this.props.content} onMakeVOWL={(vowl) => this.onMakeVOWL(vowl)}/>}
            {(this.state.action=="DETAIL")&&<DetailElement selected={this.state.selected}/>}
            {(this.state.action=="INFO")&&<InfoElement selected={this.state.selected} content={this.props.content}/>}
												
        </Modal>
                </div>            
            )
        )
    }
}

export default EMDCard;